import React from 'react';
import Button from '../base/Button/GlyphedButton';
import PropTypes from 'prop-types';

const FileItemsTableRow = (props) => {
    
    function onPreviewButtonClick(e) {
        e.preventDefault();
        props.onFilePreviewButtonClick(props.file);
    }

    function onRemoveButtonClick(e) {
        e.preventDefault();
        props.onFileRemoveButtonClick(props.file);
    }
    
    return(
        <tr key={props.file.name}>
            <td className="col-xs-8">
                {props.file.name}
            </td>
            <td className="col-xs-2">
                <Button
                    id={`btnFilePreview${props.file.name}`}
                    onClick={onPreviewButtonClick}
                    glyph="glyphicon-eye-open"
                    label="Podgląd" />
            </td>
            <td className="col-xs-2"> 
                <Button
                    id={`btnFileRemove${props.file.name}`}
                    onClick={onRemoveButtonClick}
                    glyph="glyphicon-remove"
                    label="Usuń" /> </td>
            </tr>
    );
};

FileItemsTableRow.propTypes ={
    file: PropTypes.shape({
        base64: PropTypes.string,
        name: PropTypes.string
    }),
    onFilePreviewButtonClick: PropTypes.func,
    onFileRemoveButtonClick: PropTypes.func,
};

export default FileItemsTableRow;


// WEBPACK FOOTER //
// ./src/components/File/FileItemsTableRow.js